import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { axiosDelete, axiosGet, axiosPatch, axiosPost } from 'Redux/axiosHelper'
import { PartnerSlide } from 'state/setting/partnerContent'

type PartnerPayload = Omit<PartnerSlide, 'id'>

// add partner slide
const addPartnerSlide = async (payload: PartnerPayload) => {
  const response = await axiosPost(payload, `v1/partner`)
  return response.data
}

export const useAddPartnerSlide = () => {
  return useMutation(addPartnerSlide)
}

// get partner content
const getPartnerContent = async () => {
  const response = await axiosGet(`v1/partner`)
  return response.data
}

export const useGetPartnerContent = () => {
  const partnerContent = useQuery<PartnerSlide[]>(
    ['partner-content'],
    getPartnerContent,
    {
      enabled: false,
    },
  )
  return partnerContent
}

// delete partner content
const deletePartnerContent = async (partnerId: string) => {
  const response = await axiosDelete(`v1/partner/${partnerId}`)
  return response.data
}

export const useDeletePartnerContent = () => {
  return useMutation(deletePartnerContent)
}

// update partner slide
const updatePartnerSlide = async ({
  payload,
  slideId,
}: {
  payload: PartnerPayload
  slideId: string
}) => {
  const response = await axiosPatch(payload, `v1/partner/${slideId}`)
  return response.data
}

export const useUpdatePartnerSlide = () => {
  return useMutation(updatePartnerSlide)
}

// reorder partner slides
const reorderPartnerSlides = async (payload: {
  partners: {
    partnerId: string
    order: number
  }[]
}) => {
  const response = await axiosPatch(payload, `v1/partner/order`)
  return response.data
}

export const useReorderPartnerSlides = () => {
  const queryClient = useQueryClient()
  return useMutation(reorderPartnerSlides, {
    onSuccess: data => {
      queryClient.setQueryData(['partner-content'], () => {
        return data
      })
    },
  })
}
